import { render, staticRenderFns } from "./Pdpa.vue?vue&type=template&id=a51beba6&"
import script from "./Pdpa.vue?vue&type=script&lang=js&"
export * from "./Pdpa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports